import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import projectReducer from './slices/projectListSlice';
import employeeListReducer from "./slices/employeeListSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    projectList: projectReducer,
    employeeList: employeeListReducer
  },
});
